import { Injectable } from '@angular/core';
import { api, base } from './../crypto-constants/api';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { PopoverController, ToastController } from '@ionic/angular';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { AppState } from '../store/state';
import { Store } from '@ngrx/store';
import { SET_CONTACTS } from '../store/actions/contacts.action';
import { environment } from 'src/environments/environment';
import { buildExternalAppUrl } from 'src/app/utils/app-route.util';
import { closeOutline } from 'ionicons/icons';
// import { } from '../../assets/images/download-locations/chrome-browser.png';
import { SET_PROFILE } from '../store/actions/userProfile.action';
import { map, catchError, finalize, share, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorPopupService } from './error-popup.service';
import { isScytaleKycCreditLimitError } from '../utils/scytale-kyc-retry.util';
import {
  isStandaloneKycStateNotFoundError,
  resolveStandaloneKycErrorDisplay,
} from '../utils/standalone-scytale-kyc.util';
declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  clientBaseeUrl = environment.clientBaseUrl;
  sitekey = "6LeMGhcqAAAAACxKkYWwdUTf7nFJ7GiF_lWYyNAs";
  userData: any;
  isAdminUser = false;
  indiaKycWorkflowId = 'workflow_xnIi3gl_input';
  usaKycWorkflowId = 'workflow_t9U9Kem';
  uaeKycWorkflowId = 'workflow_uae';
  ausKycWorkflowId = 'workflow_aus';
  ukKycWorkflowId = 'workflow_uk';
  kycAllowedCountries = [
    'United States',
  ];
  constructor(
    private httpClient: HttpClient,
    private toastController: ToastController,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private store: Store<AppState>,
    private popover: PopoverController,
    private router: Router,
    private errorPopup: ErrorPopupService
  ) {
    this.store.select('userProfile').subscribe((data) => {
      if (data && data.userProfile) {
        this.userData = data.userProfile;
        this.isAdminUser = this.userData.isAdmin;
      }
    });
  }

  savedBenificiariesList: any = [];
  willsList: any = [];
  private isLoading$$ = new BehaviorSubject<any>(false);
  isLoading$ = this.isLoading$$.asObservable();
  /** Debounce global overlay so route changes paint before slow APIs finish. */
  private globalLoaderPending = 0;
  private globalLoaderTimer: ReturnType<typeof setTimeout> | null = null;
  private globalLoaderSafetyTimer: ReturnType<typeof setTimeout> | null = null;
  private static readonly GLOBAL_LOADER_DELAY_MS = 500;
  private static readonly IAMRA_BOOTSTRAP_TTL_MS = 60_000;
  private static readonly IAMRA_CACHE_TTL_MS = 45_000;
  private iamraInFlight = new Map<string, Observable<any>>();
  private iamraResponseCache = new Map<string, { capturedAt: number; value: unknown }>();
  private iamraBootstrapSnapshot: {
    recentRa?: any;
    recentSecret?: any;
    capturedAt: number;
  } | null = null;
  // Safety net: forces the loader off if some caller's setLoading(true) is
  // never matched by a setLoading(false) (a leak elsewhere).
  private static readonly GLOBAL_LOADER_MAX_MS = 15000;
  public isRaOrGuardianUpdated$$ = new BehaviorSubject<any>(false);
  isRaOrGuardianUpdated$ = this.isRaOrGuardianUpdated$$.asObservable();
  public isKYCupdated$$ = new BehaviorSubject<any>(false);
  isKYCupdated$ = this.isKYCupdated$$.asObservable();
  public redirectSubject$$ = new Subject<any>();
  redirectSubject$ = this.redirectSubject$$.asObservable();
  public setGuardianTabSubject$$ = new Subject<any>();
  setGuardianTabSubject$ = this.setGuardianTabSubject$$.asObservable();
  public showOnboardingSubject$$ = new Subject<void>();
  showOnboardingSubject$ = this.showOnboardingSubject$$.asObservable();
  public userRoleSet$$ = new Subject<{ role?: string }>();
  // userRoleSet$ = this.userRoleSet$$.asObservable();
  savedBinders: any[] = [];
  public navigationUserRoleSet$$ = new Subject<{ role?: string }>();
  navigationUserRoleSet$ = this.navigationUserRoleSet$$.asObservable();
  public dashboardRoleSetForHeader$$ = new Subject<{ role?: string }>();
  dashboardRoleSetForHeader$ = this.dashboardRoleSetForHeader$$.asObservable();
  
  public profileImageUpdated$$ = new Subject<void>();
  profileImageUpdated$ = this.profileImageUpdated$$.asObservable();

  /**
   * Display name for current paid tier — same source as
   * SubscriptionManagementNewComponent (GET .../legacy/digital/stripe-session/plan).
   */
  private subscriptionPlanName$$ = new BehaviorSubject<string | null>(null);
  subscriptionPlanName$ = this.subscriptionPlanName$$.asObservable();

  /**
   * B2B workspace: business routes or logged-in business user with session details.
   * Legacy consumer plan API must not run in this context.
   */
  isB2bAccess(url?: string): boolean {
    try {
      const accountType = localStorage.getItem('accountType') === 'B';
      const hasBusinessUserDetails = !!(
        sessionStorage.getItem('clocr_buser') || localStorage.getItem('businessUser')
      );
      const pathsToCheck: string[] = [];
      if (url) {
        pathsToCheck.push(url);
      }
      try {
        if (this.router?.url) {
          pathsToCheck.push(this.router.url);
        }
      } catch {
        /* ignore */
      }
      if (typeof window !== 'undefined') {
        pathsToCheck.push(window.location.pathname || '');
        const hash = window.location.hash || '';
        if (hash.startsWith('#')) {
          pathsToCheck.push(hash.slice(1));
        }
      }
      const isBusinessRoute = pathsToCheck.some((raw) => {
        const pathOnly = (raw || '').toLowerCase().split('?')[0].split('#')[0];
        return (
          pathOnly === '/business' ||
          pathOnly.startsWith('/business/') ||
          pathOnly.includes('/business-dashboard')
        );
      });
      return isBusinessRoute || (accountType && hasBusinessUserDetails);
    } catch {
      return false;
    }
  }

  /** Advisor viewing a specific client under /business/client/:id/* */
  isInB2bClientWorkspace(): boolean {
    const paths: string[] = [];
    try {
      if (this.router?.url) {
        paths.push(this.router.url);
      }
    } catch {
      /* ignore */
    }
    if (typeof window !== 'undefined') {
      paths.push(window.location.pathname || '');
      const hash = window.location.hash || '';
      if (hash.startsWith('#')) {
        paths.push(hash.slice(1));
      }
    }
    return paths.some((p) =>
      (p || '').toLowerCase().includes('/business/client/')
    );
  }

  /** B2B wills/trusts/cryptowill APIs need type=business (and clientId in client workspace). */
  shouldAttachB2bWillTrustParams(): boolean {
    return (
      localStorage.getItem('accountType') === 'B' ||
      this.isB2bAccess() ||
      this.isInB2bClientWorkspace()
    );
  }

  private extractClientIdFromRoutePath(path: string): string | null {
    const parts = (path || '').toLowerCase().split(/[?#]/)[0].split('/').filter(Boolean);
    const clientIdx = parts.indexOf('client');
    if (clientIdx < 0 || !parts[clientIdx + 1]) {
      return null;
    }
    const cid = parts[clientIdx + 1];
    const looksLikeTabSlug =
      /^(dashboard|files|emergency-binder|online-accounts|asset-portfolio|time-capsule|directives|contacts|passwords|onboarding-details|your-plan|clients|client)$/i;
    if (cid && !looksLikeTabSlug.test(cid)) {
      return cid;
    }
    return null;
  }

  /** Client id when advisor is on /business/client/:id/* (directives, wills, trusts, etc.). */
  resolveB2bClientId(): string | null {
    const pathsToCheck: string[] = [];
    try {
      if (this.router?.url) {
        pathsToCheck.push(this.router.url);
      }
    } catch {
      /* ignore */
    }
    try {
      if (typeof window !== 'undefined') {
        pathsToCheck.push(window.location.pathname || '');
        const hash = window.location.hash || '';
        if (hash.startsWith('#')) {
          pathsToCheck.push(hash.slice(1));
        }
      }
    } catch {
      /* ignore */
    }
    for (const path of pathsToCheck) {
      const fromRoute = this.extractClientIdFromRoutePath(path);
      if (fromRoute) {
        return fromRoute;
      }
    }
    try {
      const stored =
        sessionStorage.getItem('b2b_client_id') ||
        localStorage.getItem('b2b_client_id');
      if (stored && String(stored).trim() !== '') {
        return String(stored).trim();
      }
    } catch {
      /* ignore */
    }
    try {
      const raw =
        sessionStorage.getItem('client_details') ||
        localStorage.getItem('client_details');
      if (raw) {
        const o = JSON.parse(raw);
        const cid =
          o?.id ?? o?.clientId ?? o?.client_id ?? o?.fk_userid ?? o?.user_id;
        if (cid != null && String(cid).trim() !== '') {
          return String(cid);
        }
      }
    } catch {
      /* ignore */
    }
    return null;
  }

  isB2bWillTrustOrCryptowillUrl(url: string): boolean {
    const u = (url || '').toLowerCase();
    if (u.includes('/cryptowill')) {
      return true;
    }
    // Revocable living trust — exclude /user/trustee/*
    if (u.includes('/user/trust') && !u.includes('/user/trustee')) {
      return true;
    }
    if (u.includes('/user/will')) {
      return true;
    }
    return false;
  }

  /** Shared HttpClient options for /cryptowill, /user/trust, /user/will */
  b2bWillTrustHttpOptions(
    extra?: Record<string, string | number | undefined | null>
  ): { params: HttpParams } {
    return { params: this.b2bWillTrustQueryParams(extra) };
  }

  /**
   * B2B: append ?type=business (& clientId when in client workspace) for
   * /cryptowill, /user/trust, /user/will.
   */
  b2bWillTrustQueryParams(
    extra?: HttpParams | Record<string, string | number | undefined | null>
  ): HttpParams {
    let params = extra instanceof HttpParams ? extra : new HttpParams();
    if (extra && !(extra instanceof HttpParams)) {
      Object.entries(extra).forEach(([key, val]) => {
        if (val != null && val !== '') {
          params = params.set(key, String(val));
        }
      });
    }
    if (!this.shouldAttachB2bWillTrustParams()) {
      return params;
    }
    if (!params.has('type')) {
      params = params.set('type', 'business');
    }
    const clientId = this.resolveB2bClientId();
    if (clientId && !params.has('clientId')) {
      params = params.set('clientId', clientId);
    }
    return params;
  }

  fetchLegacyDigitalSubscriptionPlan(): void {
    if (this.isB2bAccess()) {
      return;
    }
    const endpoint = `${base}/legacy/digital/stripe-session/plan`;
    this.httpClient
      .get<any>(endpoint, { params: { dbName: 'clocrus' } })
      .pipe(
        map((res) => {
          const planData = res?.data || res;
          const raw = planData?.plan;
          return raw != null && String(raw).trim() !== ''
            ? String(raw).trim()
            : 'Free';
        }),
        catchError(() => of('Free'))
      )
      .subscribe((name) => this.subscriptionPlanName$$.next(name));
  }

  /** Called when subscription-management loads so the sidebar stays in sync without waiting for another GET */
  setSubscriptionPlanNameForShell(planName: string): void {
    const t = planName != null ? String(planName).trim() : '';
    this.subscriptionPlanName$$.next(t || 'Free');
  }

  // Client app details observable for communication between root and dashboard components
  public clientAppDetails$$ = new BehaviorSubject<any>(null);
  clientAppDetails$ = this.clientAppDetails$$.asObservable();
  /** Ask any open Secure Shell modal to close (e.g. KYC credit error or navigation). */
  private requestCloseShellModal$$ = new Subject<void>();
  requestCloseShellModal$ = this.requestCloseShellModal$$.asObservable();

  requestCloseShellModal(): void {
    this.requestCloseShellModal$$.next();
  }

  private sharedMeTableCols = new BehaviorSubject<any>(null);

  // Expose the BehaviorSubject as an Observable
  sharedTableCols$ = this.sharedMeTableCols.asObservable();

  setSharedData(value: any): void {
    this.sharedMeTableCols.next(value);
  }

  // Method to get the current value
  getSharedData(): any {
    return this.sharedMeTableCols.getValue();
  }

  /** Phone / tablet browser. Desktop Chrome and Toughbrowser stay false. */
  isMobileBrowser(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent || ''
    );
  }

  /**
   * Client-app actions need the desktop app. Shows a modal on a mobile browser
   * and returns true so callers can stop. Desktop browsers are unchanged.
   */
  showDesktopRequiredForClientAction(): boolean {
    if (!this.isMobileBrowser()) {
      return false;
    }
    void this.errorPopup.show(
      'Please use a desktop browser for this action.',
      'Use desktop'
    );
    return true;
  }

  async showToasterMessage(
    message: string,
    position: 'top' | 'middle' | 'bottom',
    toasterType: string,
    downloadPopup = false
  ) {
    const normalizedType = (toasterType || '').toLowerCase();
    if (
      !downloadPopup &&
      ['danger', 'warning', 'error'].includes(normalizedType)
    ) {
      if (!this.errorPopup.isSessionExpired()) {
        const text = message || 'Something went wrong';
        if (isScytaleKycCreditLimitError({ message: text })) {
          this.requestCloseShellModal();
          await this.errorPopup.show(text, '', {
            primaryButtonText: 'Buy',
            navigateTo: '/profile/subscription',
            onPrimaryAction: () => this.requestCloseShellModal(),
          });
        } else if (isStandaloneKycStateNotFoundError(text)) {
          const display = resolveStandaloneKycErrorDisplay('State not found');
          await this.errorPopup.show(
            display.detail ?? text,
            display.message,
            {
              primaryButtonText: 'Go to profile',
              navigateTo: '/profile/personal-details',
            }
          );
        } else if (text === 'Client Application related activities are not available') {
          await this.errorPopup.show(
            'Please use a desktop browser for this action.',
            'Use desktop'
          );
        } else {
          await this.errorPopup.show(text);
        }
      }
      return;
    }

    const toast = await this.toastController.create({
      message: message,
      duration: downloadPopup ? 15000 : 1500,
      position: position,
      buttons: downloadPopup
        ? [
          {
            side: 'end',
            icon: closeOutline as any,
          },
        ]
        : [],
      cssClass: downloadPopup
        ? [toasterType + '-toaster', 'download-popup-toaster']
        : [toasterType + '-toaster', 'toaster-message'],
      color: downloadPopup ? '' : toasterType,
    });

    if (downloadPopup) {
      const toastMessage = toast.shadowRoot?.querySelector(
        '.toast-message'
      ) as HTMLElement | null;
      if (toastMessage) {
        toastMessage.style.display = 'flex';
        toastMessage.style.flexDirection = 'column';
        toastMessage.style.alignItems = 'center';
        toastMessage.style.justifyContent = 'flex-start';
        toastMessage.style.gap = '12px';
        toastMessage.style.width = '100%';
        toastMessage.style.textAlign = 'center';
      }

      const div = document.createElement('div');
      div.style.flex = '1';
      div.style.minWidth = '0';
      const p = document.createElement('p');
      p.textContent = 'MyLegacy Secure Shell is being downloaded.';
      // toast.shadowRoot?.querySelector('.toast-message')?.appendChild(p);
      div?.appendChild(p);
      const p1 = document.createElement('p');
      p1.textContent = 'Check your Downloads section.';
      div?.appendChild(p1);
      if (this.isEdgeBrowser()) {
        const pKeep = document.createElement('p');
        pKeep.innerHTML =
          '<strong>Microsoft Edge:</strong> If you see &ldquo;isn&rsquo;t commonly downloaded&rdquo;, open the <strong>Downloads</strong> panel (&darr; top-right), click <strong>&hellip;</strong> next to the file, then click <strong>Keep</strong>.';
        div?.appendChild(pKeep);
      } else if (this.isChromiumBrowser()) {
        const pKeep = document.createElement('p');
        pKeep.textContent =
          'If your browser warns the file may be unsafe, click Keep to save the installer.';
        div?.appendChild(pKeep);
      }
      const p2 = document.createElement('p');
      p2.textContent =
        'Install the application after the download is complete.';
      // toast.shadowRoot?.querySelector('.toast-message')?.appendChild(p2);
      div?.appendChild(p2);
      const p3 = document.createElement('p');
      p3.textContent = 'You can close this window now.';
      // toast.shadowRoot?.querySelector('.toast-message')?.appendChild(p3);
      div?.appendChild(p3);
      toastMessage?.appendChild(div);
    }

    await toast.present();

    if (downloadPopup) {
      this.compactDownloadToastDismissButton(toast);
    }
  }

  private compactDownloadToastDismissButton(toast: HTMLIonToastElement): void {
    const closeButton = toast.shadowRoot?.querySelector(
      'button.toast-button',
    ) as HTMLElement | null;
    if (!closeButton) {
      return;
    }
    closeButton.style.setProperty('width', '28px');
    closeButton.style.setProperty('height', '28px');
    closeButton.style.setProperty('min-height', '28px');
    closeButton.style.setProperty('margin', '0');
    closeButton.style.setProperty('padding', '0');
    closeButton.style.setProperty('font-size', '20px');

    const icon = closeButton.querySelector('ion-icon') as HTMLElement | null;
    if (icon) {
      icon.style.setProperty('font-size', '20px');
      icon.style.setProperty('width', '20px');
      icon.style.setProperty('height', '20px');
    }
  }

  setLoading(isLoading: boolean) {
    if (isLoading) {
      this.globalLoaderPending++;
      if (!this.globalLoaderTimer && !this.isLoading$$.value) {
        this.globalLoaderTimer = setTimeout(() => {
          this.globalLoaderTimer = null;
          if (this.globalLoaderPending > 0) {
            this.isLoading$$.next(true);
          }
        }, CommonService.GLOBAL_LOADER_DELAY_MS);
      }
      if (!this.globalLoaderSafetyTimer) {
        this.globalLoaderSafetyTimer = setTimeout(() => {
          console.warn(
            '[global-loader] pending count never reached zero — forcing loader off. ' +
            'Some caller likely leaked setLoading(true) without a matching setLoading(false).'
          );
          this.globalLoaderPending = 0;
          this.globalLoaderSafetyTimer = null;
          this.hideGlobalLoaderNow();
        }, CommonService.GLOBAL_LOADER_MAX_MS);
      }
      return;
    }

    this.globalLoaderPending = Math.max(0, this.globalLoaderPending - 1);
    if (this.globalLoaderPending > 0) {
      return; // another concurrent caller is still loading
    }
    this.hideGlobalLoaderNow();
  }

  private hideGlobalLoaderNow(): void {
    if (this.globalLoaderTimer) {
      clearTimeout(this.globalLoaderTimer);
      this.globalLoaderTimer = null;
    }
    if (this.globalLoaderSafetyTimer) {
      clearTimeout(this.globalLoaderSafetyTimer);
      this.globalLoaderSafetyTimer = null;
    }
    this.isLoading$$.next(false);
  }

  getKycWorkflowId(country: string) {
    console.log(country, 'country');
    switch (country) {
      case 'India':
        return this.indiaKycWorkflowId;
        break;
      case 'United States':
        return this.usaKycWorkflowId;
        break;
      case 'Australia':
        return this.ausKycWorkflowId;
        break;
      case 'United Arab Emirates':
        return this.uaeKycWorkflowId;
        break;
      case 'United Kingdom':
        return this.ukKycWorkflowId;
        break;
      default:
        return this.indiaKycWorkflowId;
        break;
    }
  }

  getKycWorkflowIdforInitiateRecover(country: string) {
    console.log(country, 'country');
    switch (country) {
      case 'India':
        return 'workflow_xnIi3gl_input';
        break;
      case 'United States':
        return 'workflow_t9U9Kem_input';
        break;
      case 'Australia':
        return 'workflow_aus_input';
        break;
      case 'United Arab Emirates':
        return 'workflow_uae_input';
        break;
      case 'United Kingdom':
        return 'workflow_uk_input';
        break;
      default:
        return 'workflow_xnIi3gl_input';
        break;
    }
  }

  isKycAllowed(country: string) {
    return this.kycAllowedCountries.indexOf(country);
  }

  generaterecaptchaToken() {
    let promise = new Promise((reslove, reject) => {
      this.reCaptchaV3Service.execute(
        this.sitekey,
        'submit',
        (token: any) => {
          reslove(token);
        },
        {
          useGlobalDomain: false,
        }
      );
    });
    return promise;
  }

  checkDevicePermission(uuid: any, deviceId: any) {
    return this.httpClient.post(api.checkDevicePermission, {
      deviceId: deviceId,
      uuid: uuid,
      os: 'windows',
    });
  }

  isLoggedIn(): Observable<boolean> {
    const user = sessionStorage.getItem('user');
    if (user) {
      return of(true);
    }

    // Business auth (and some flows) persist auth in localStorage
    const token = localStorage.getItem('token');
    if (token && token.trim().length > 0) {
      return of(true);
    }

    return of(false);
  }

  isAdmin() {
    if (this.isDelegationAdmin()) {
      return false;
    }
    let isAdmin = false;
    let isLoggedInAsAdmin = false;

    try {
      isAdmin = JSON.parse(sessionStorage.getItem('user'))?.isAdmin;
      isLoggedInAsAdmin = JSON.parse(localStorage.getItem('isLoggedInAsAdmin'));
    } catch (error) {
      console.error("Failed to parse JSON data:", error);
    }

    return (this.isAdminUser || isAdmin) && isLoggedInAsAdmin;
  }

  /** True when user logged in as delegation admin (TOD / ToughKey delegation workflow). */
  isDelegationAdmin(): boolean {
    try {
      const isLoggedIn = localStorage.getItem('isLoggedInAsDelegationAdmin') === 'true';
      const user = sessionStorage.getItem('user');
      const isDelegationRole = user ? (JSON.parse(user)?.isDelegationAdmin === true) : false;
      return isLoggedIn || isDelegationRole;
    } catch {
      return false;
    }
  }

getCountriesPromise(): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const cachedCountries = localStorage.getItem('countries');

    if (cachedCountries) {
      try {
        const parsed = JSON.parse(cachedCountries);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return resolve(parsed);
        }
      } catch (err) {
        console.warn('Invalid countries in localStorage', err);
        // Proceed to fetch from API
      }
    }

    this.httpClient.get(api.CountriesList).toPromise()
      .then((response: any) => {
        if (response?.success && Array.isArray(response.data)) {
          const processedData = response.data
            .map((country: any) => ({
              ...country,
              filterKey: `${country.country} ${country.iso2} ${country.countryCode}`
            }))
            .sort((a: any, b: any) => a.country.localeCompare(b.country));

          localStorage.setItem('countries', JSON.stringify(processedData));
          resolve(processedData);
        } else {
          // Fallback to JSON file if API response is invalid
          console.warn('Invalid API response, falling back to JSON file');
          this.loadCountriesFromJson()
            .then(resolve)
            .catch(reject);
        }
      })
      .catch((error) => {
        console.error('Error fetching countries from API, falling back to JSON file:', error);
        // Fallback to JSON file when API fails
        this.loadCountriesFromJson()
          .then(resolve)
          .catch(reject);
      });
  });
}

/**
 * Load countries from local JSON file as fallback
 */
private loadCountriesFromJson(): Promise<any[]> {
  return new Promise((resolve, reject) => {
    this.httpClient.get('/assets/constants/countries.json').toPromise()
      .then((countriesData: any) => {
        if (Array.isArray(countriesData) && countriesData.length > 0) {
          const processedData = countriesData
            .map((country: any) => ({
              ...country,
              filterKey: `${country.country} ${country.iso2} ${country.countryCode}`
            }))
            .sort((a: any, b: any) => a.country.localeCompare(b.country));

          console.log('Loaded countries from JSON file:', processedData.length);
          // Cache in localStorage for future use
          localStorage.setItem('countries', JSON.stringify(processedData));
          resolve(processedData);
        } else {
          reject('Invalid countries data in JSON file');
        }
      })
      .catch((error) => {
        console.error('Error loading countries from JSON file:', error);
        reject(error);
      });
  });
}


  getStates(countryId: number): Observable<any> {
    // Load directly from local JSON files instead of API
    return this.getStatesFromLocalJson(countryId);
  }

  private getStatesFromLocalJson(countryId: number): Observable<any> {
    // Map country IDs to their corresponding JSON files
    const countryFileMap: { [key: number]: string } = {
      1: '1_us.json',    // United States
      2: '2_ca.json',    // Canada  
      3: '3_in.json',    // India
      4: '4_au.json',    // Australia
      33: '33_uk.json'   // United Kingdom
    };

    const fileName = countryFileMap[countryId];
    
    if (!fileName) {
      console.error(`No local JSON file found for country ID: ${countryId}`);
      return of({ success: false, data: [], message: 'No states data available' });
    }

    // Use HttpClient to fetch the JSON file from assets
    return this.httpClient.get(`/assets/constants/${fileName}`).pipe(
      map((statesData: any) => {
        console.log(`Loaded ${statesData.length} states from local JSON for country ${countryId}`);
        return {
          success: true,
          data: statesData,
          message: 'States loaded from local data'
        };
      }),
      catchError((error) => {
        console.error(`Failed to load local states JSON for country ${countryId}:`, error);
        return of({ success: false, data: [], message: 'Failed to load local states data' });
      })
    );
  }

  getBusinessTypes(countryId: number = 1): Observable<any> {
    return this.httpClient.get(`${api.getBusinessTypes}?countryId=${countryId}`);
  }

  handleError(error: any) {
    if (this.errorPopup.isSessionExpired()) {
      return;
    }
    this.errorPopup.showFromError(error, 'Something went wrong');
  }

  resolveErrorMessage(error: any, fallback = 'Something went wrong'): string {
    return this.errorPopup.resolveErrorMessage(error, fallback);
  }

  /** Centered Ionic alert for login/signup and other auth errors (replaces danger toasters). */
  async showErrorAlert(message: string, header = ''): Promise<void> {
    return this.errorPopup.show(message, header);
  }

  consumeSessionExpiredAlert(): boolean {
    return this.errorPopup.consumeSessionExpiredAlert();
  }

  resetErrorPopupSession(): void {
    this.errorPopup.resetSessionState();
  }

  showAuthError(error: any, fallback = 'Something went wrong'): void {
    this.errorPopup.showFromError(error, fallback);
  }

  getKycToken(transId: string, from: string) {
    return this.httpClient.get(
      api.getKycToken + '?transId=' + transId + '&from=' + from
    );
  }

  /** Ensure API-provided installer URLs open externally (not as Angular routes). */
  normalizeExternalUrl(url: string): string {
    const trimmed = (url || '').trim();
    if (!trimmed) {
      return '';
    }
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    if (trimmed.startsWith('//')) {
      return `https:${trimmed}`;
    }
    return `https://${trimmed}`;
  }

  /**
   * Start a file download from a user click in Chrome, Edge, Firefox, and Safari.
   * Cross-origin installers ignore the download attribute, so those navigate in a new tab.
   * Same-origin files (the instructions PDF) use the download attribute.
   */
  private openInstallerDownload(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    try {
      const target = new URL(url, window.location.href);
      if (target.origin === window.location.origin) {
        const name = target.pathname.split('/').pop();
        if (name) {
          link.download = decodeURIComponent(name);
        }
      }
    } catch {
      // Keep a plain navigation when the URL cannot be parsed.
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadApplication(OS: String, version: string, urlOverride?: string) {
    let className = this.detectBrowserName();
    const localUser = this.getLocalUserRecord();
    let url = urlOverride;
    if (OS === 'WIN') {
      url =
        url ||
        this.userData?.msi_url ||
        localUser?.msi_url ||
        environment.clientAppUrl;
    } else if (OS === 'ARM64' || OS === 'X86_64' || OS === 'MAC') {
      url =
        url ||
        this.userData?.mac_url ||
        localUser?.mac_url ||
        environment.macClientAppUrl;
    }
    url = this.normalizeExternalUrl(url);
    if (!url) {
      return;
    }
    const position: 'top' = 'top';
    this.openInstallerDownload(url);
    // this.openInstallerDownload('/assets/files/instructions.pdf');
    localStorage.removeItem('clientAppVersionMismatch');
    localStorage.setItem('clientAppDownloaded', 'true');
    this.showToasterMessage('', position, className, true);
    // Mark download started only — installed_version is set from live /getInfo after install.
    this.updateClientAppStatus({
      last_status_result: 'DOWNLOADED',
      app_downloaded_date: new Date(),
      client_app_downloaded: 'YES',
      last_status_result_date: new Date(),
    });
  }

  getOsName(): string {
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      return 'MAC';
    } else {
      return 'WIN';
    }
  }

  private getLocalUserRecord(): any {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  }

  updateClientAppStatus(data: any) {
    this.httpClient.put(api.updateClientAppStatus, data).subscribe(() => {
      this.getUserDetails().subscribe((data) => {
        this.store.dispatch({ type: SET_PROFILE, userProfile: data['data'] });
      });
    });
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1 || agent.indexOf('edg') > -1:
        return 'edge-downloaded-popup';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome-downloaded-popup';
      case agent.indexOf('firefox') > -1:
        return 'firefox-downloaded-popup';
      case agent.indexOf('safari') > -1:
        return 'safari-downloaded-popup';
      default:
        return 'firefox-downloaded-popup';
    }
  }

  isChromiumBrowser(): boolean {
    const agent = window.navigator.userAgent.toLowerCase();
    return (
      (agent.indexOf('chrome') > -1 && !!(<any>window).chrome) ||
      agent.indexOf('edge') > -1 ||
      agent.indexOf('edg') > -1
    );
  }

  isEdgeBrowser(): boolean {
    const agent = window.navigator.userAgent.toLowerCase();
    return agent.indexOf('edge') > -1 || agent.indexOf('edg') > -1;
  }

  isFirefoxBrowser(): boolean {
    const agent = window.navigator.userAgent.toLowerCase();
    return agent.indexOf('firefox') > -1;
  }

  isDuckDuckGoBrowser(): boolean {
    const agent = window.navigator.userAgent.toLowerCase();
    return agent.includes('duckduckgo') || /ddg/i.test(navigator.userAgent);
  }

  /** Primary Google Chrome — excludes Edge, Firefox, DuckDuckGo, Opera. */
  isGoogleChromeBrowser(): boolean {
    if (this.isEdgeBrowser() || this.isFirefoxBrowser() || this.isDuckDuckGoBrowser()) {
      return false;
    }
    const agent = window.navigator.userAgent.toLowerCase();
    return agent.indexOf('chrome') > -1 && !!(<any>window).chrome;
  }

  /**
   * Browsers that often need extra localhost / launch guidance (Chrome usually works without).
   */
  needsSecureShellBrowserConnectHelp(): boolean {
    if (
      this.isEdgeBrowser() ||
      this.isFirefoxBrowser() ||
      this.isDuckDuckGoBrowser()
    ) {
      return true;
    }
    // Chrome (non-Edge): https → http://localhost:3000 needs Local network access (PNA).
    if (this.isChromiumBrowser()) {
      const host = window.location.hostname.toLowerCase();
      return host !== 'localhost' && host !== '127.0.0.1';
    }
    return false;
  }

  /** Show localhost permission help in Secure Shell modals and vault. */
  shouldShowSecureShellLocalhostHelp(): boolean {
    return this.isChromiumBrowser() || this.isFirefoxBrowser();
  }

  /** Edge: local network access for dev.my-legacy.ai → localhost:3000 */
  openLocalNetworkAccessSettings(): void {
    if (this.isEdgeBrowser()) {
      window.open('edge://settings/content/localNetworkAccess', '_blank');
      return;
    }
    if (this.isDuckDuckGoBrowser() && this.isChromiumBrowser()) {
      const site = encodeURIComponent(`${window.location.origin}/`);
      window.open(`chrome://settings/content/siteDetails?site=${site}`, '_blank');
      return;
    }
    if (this.isFirefoxBrowser()) {
      window.open('about:preferences#privacy', '_blank');
      return;
    }
    if (this.isChromiumBrowser()) {
      const site = encodeURIComponent(`${window.location.origin}/`);
      window.open(`chrome://settings/content/siteDetails?site=${site}`, '_blank');
    }
  }

  getContacts() {
    this.httpClient
      .get(api.careTaker)
      .toPromise()
      .then((response: any) => {
        if (response && response['success']) {
          // this.showToasterMessage("Contact created", "top","success");
          this.store.dispatch({
            type: SET_CONTACTS,
            contacts: response['data'],
          });
        } else {
          console.log(response);
          this.handleError(response['message']);
        }
      })
      .catch((error) => {
        console.log(error);
        this.handleError(error?.error?.message);
      });
  }

  getSavedWills() {
    return this.httpClient.get(api.getWillList, this.b2bWillTrustHttpOptions());
    // .subscribe((response :any) => {
    //   if(response.success) {
    //     this.store.dispatch( { type : SET_CONTACTS , contacts : response['data'] } );
    //   }
    // }
    // )
  }

  getSavedBenificiaries() {
    let promise = new Promise((resolve, reject) => {
      if (this.savedBenificiariesList && this.savedBenificiariesList.length) {
        resolve(this.savedBenificiariesList);
      } else {
        this.getSavedWills().subscribe((wills: any) => {
          // console.log(wills.data);
          this.willsList = wills.data;
          if (wills && wills.data && wills.data.length) {
            wills.data.forEach((will: any, index: number) => {
              if (will.careTakerDetails && will.careTakerDetails.length) {
                will.careTakerDetails.forEach((element: any) => {
                  let checkForDuplicate = this.savedBenificiariesList.find(
                    (el: any) => el.user_email === element.user_email
                  );
                  if (!checkForDuplicate) {
                    let obj = {
                      user_first_name: element.user_first_name,
                      user_last_name: element.user_last_name,
                      user_email: element.user_email,
                      relationship: element.relationship,
                      user_caretaker_id: element.user_caretaker_id,
                      wills: [will.name],
                    };
                    this.savedBenificiariesList.push(obj);
                  } else {
                    checkForDuplicate.wills.push(will.name);
                  }
                });
              }
              if (wills.data.length === index + 1) {
                resolve(this.savedBenificiariesList);
              }
            });
          } else {
            resolve([]);
          }
        });
      }
    });
    return promise;
  }

  private callScytaleKycApi(inputJwtToken: string, transactionId: string, from: string) {
    // Dynamically determine base URL based on current environment
    let baseUrl = window.location.origin;
    const hostname = window.location.hostname.toLowerCase();
    
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('localhost:') || hostname.startsWith('127.0.0.1:')) {
      baseUrl = window.location.origin;
      console.log('callScytaleKycApi - Localhost detected, using current origin:', baseUrl);
    } else if (hostname.includes('dev') || hostname.includes('dev.my-legacy.ai') || hostname.includes('dev.clocr.com')) {
      baseUrl = this.clientBaseeUrl || 'https://dev.my-legacy.ai';
      baseUrl = baseUrl.replace(/\/$/, '');
      console.log('callScytaleKycApi - Dev environment detected, using:', baseUrl);
    } else if (hostname.includes('prod') || hostname === 'my-legacy.ai' || hostname.includes('prod.my-legacy.ai')) {
      baseUrl = 'https://my-legacy.ai';
      console.log('callScytaleKycApi - Production environment detected, using:', baseUrl);
    } else {
      baseUrl = window.location.origin;
      console.log('callScytaleKycApi - Fallback, using current origin:', baseUrl);
    }
    
    const callbackUrl = buildExternalAppUrl('/profile/kyc-details', baseUrl) + '?scytale=true';
    console.log('callScytaleKycApi - Callback URL:', callbackUrl);
    console.log('callScytaleKycApi - Sending request with inputJwtToken');

    // Call Scytale KYC API with JWT token
    this.httpClient.post<any>(api.scytaleKYC, {
      callbackUrl: callbackUrl,
      transactionId: transactionId,
      from: from,
      inputJwtToken: inputJwtToken
    })
    .subscribe(
      (res) => {
        console.log('Scytale KYC API response received');
        if (res && res.success && res.kyc_data?.resultObject?.sessionUrl) {
          console.log('Scytale sessionUrl:', res.kyc_data.resultObject.sessionUrl);
          
          // Store session ID if available
          if (res.kyc_data?.resultObject?.sessionId || res.kyc_data?.resultObject?.sessionID) {
            const sessionId = res.kyc_data.resultObject.sessionId || res.kyc_data.resultObject.sessionID;
            localStorage.setItem('scytaleSessionID', sessionId);
            console.log('Stored sessionID from response in localStorage:', sessionId);
          }
          
          // Request camera and microphone permissions before redirecting to Scytale
          if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            console.log('Requesting camera and microphone permissions before redirecting to Scytale');
            
            navigator.mediaDevices.getUserMedia({
              video: {
                facingMode: 'user',
                width: { ideal: 1280 },
                height: { ideal: 720 }
              },
              audio: true
            })
            .then((stream) => {
              console.log('Camera and microphone permissions granted');
              
              setTimeout(() => {
                stream.getTracks().forEach(track => {
                  track.stop();
                  console.log('Stopped track:', track.kind);
                });
                
                setTimeout(() => {
                  console.log('Redirecting to Scytale with camera permissions granted');
                  const sessionUrl = res.kyc_data.resultObject.sessionUrl;
                  window.location.href = sessionUrl;
                }, 200);
              }, 300);
            })
            .catch((err) => {
              console.warn('Camera/microphone permission denied or not available:', err);
              
              let errorMessage = 'Camera access is required for KYC verification. ';
              if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                errorMessage += 'Please allow camera access in your browser settings and try again.';
              } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
                errorMessage += 'No camera device found. Please connect a camera and try again.';
              } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
                errorMessage += 'Camera is already in use by another application. Please close it and try again.';
              } else {
                errorMessage += 'Please check your camera settings and try again.';
              }
              
              this.showToasterMessage(
                errorMessage,
                'top',
                'warning'
              );
              
              setTimeout(() => {
                const sessionUrl = res.kyc_data.resultObject.sessionUrl;
                window.location.href = sessionUrl;
              }, 500);
            });
          } else {
            console.warn('getUserMedia is not available - browser may not support camera access');
            this.showToasterMessage(
              'Camera access is not available in this browser. Please use a modern browser with camera support.',
              'top',
              'warning'
            );
            
            setTimeout(() => {
              const sessionUrl = res.kyc_data.resultObject.sessionUrl;
              window.location.href = sessionUrl;
            }, 500);
          }
        } else {
          this.showToasterMessage(
            'Unable to initiate KYC verification',
            'top',
            'danger'
          );
        }
      },
      (err) => {
        console.log('Error initiating scytale KYC', err);
        this.showToasterMessage(
          'Unable to initiate KYC verification',
          'top',
          'danger'
        );
      }
    );
  }

  startKyc(from: any = 'KYC_DETAILS') {
    if (this.userData.user_country) {
      if (this.isKycAllowed(this.userData.user_country.country) !== -1) {
        // COMMENTED OUT: Hyperverge KYC code
        // let transactionId = 'SELF_' + this.userData.uuid;
        // this.getKycToken(transactionId, from).subscribe(
        //   (data: any) => {
        //     if (data.success) {
        //       // let workflowId = this.userData.user_country.country === 'India' ? 'workflow_xnIi3gl' : 'workflow_t9U9Kem';
        //       let workflowId = this.getKycWorkflowId(
        //         this.userData.user_country.country
        //       );
        //       let token = data.data;
        //       const hyperKycConfig = new window.HyperKycConfig(
        //         token,
        //         workflowId,
        //         transactionId
        //       );
        //       window.HyperKYCModule.launch(hyperKycConfig, this.handler);
        //     }
        //   },
        //   (error: any) => {
        //     let message =
        //       error && error.error && error.error.message
        //         ? error.error.message
        //         : 'Unable to start KYC';
        //     this.showToasterMessage(message, 'top', 'danger');
        //   }
        // );

        // SCYTALE KYC LOGIC (similar to secrets vault)
        let transactionId = 'SELF_' + this.userData.uuid;
        
        // First, get the JWT token for KYC
        this.getKycToken(transactionId, from).subscribe(
          (tokenData: any) => {
            if (!tokenData.success || !tokenData.data) {
              this.showToasterMessage(
                'Unable to get KYC token',
                'top',
                'danger'
              );
              return;
            }

            // Extract JWT token from Bearer token (remove "Bearer " prefix if present)
            let extractedToken = tokenData.data;
            if (extractedToken.startsWith('Bearer ')) {
              extractedToken = extractedToken.substring(7);
            }

            // Try to get the legacy JWT token, but fallback to extracted token if it fails
            this.httpClient.get(api.getKycLegacyToken + '?transId=' + transactionId + '&from=' + from)
              .subscribe(
                (legacyTokenData: any) => {
                  // Use legacy token if available, otherwise use extracted token
                  const inputJwtToken = (legacyTokenData.success && legacyTokenData.data) 
                    ? legacyTokenData.data 
                    : extractedToken;
                  console.log('Got JWT token for Scytale KYC', legacyTokenData.success ? '(from legacy endpoint)' : '(using extracted token)');

                  // Continue with Scytale API call
                  this.callScytaleKycApi(inputJwtToken, transactionId, from);
                },
                (legacyTokenError: any) => {
                  // Legacy token endpoint failed, use extracted token as fallback
                  console.log('Legacy token endpoint failed, using extracted token as fallback', legacyTokenError);
                  console.log('Using extracted JWT token for Scytale KYC');
                  
                  // Continue with Scytale API call using extracted token
                  this.callScytaleKycApi(extractedToken, transactionId, from);
                }
              );
          },
          (tokenError: any) => {
            console.log('Error getting KYC token', tokenError);
            let message =
              tokenError && tokenError.error && tokenError.error.message
                ? tokenError.error.message
                : 'Unable to get KYC token';
            this.showToasterMessage(message, 'top', 'danger');
          }
        );
      } else {
        this.showToasterMessage(
          'KYC available only for India and United States',
          'top',
          'danger'
        );
      }
    } else {
      this.showToasterMessage(
        'Please update your country before start KYC',
        'top',
        'danger'
      );
    }
  }

  handler = (HyperKycResult: any) => {
    // let _that = this;
    switch (HyperKycResult.status) {
      case 'user_cancelled':
        this.updateKycStatus();
        this.showToasterMessage('KYC cancelled', 'top', 'danger');
        break;
      case 'error':
        this.updateKycStatus();
        this.showToasterMessage('Unable to complete KYC', 'top', 'danger');
        break;
      case 'auto_approved':
        this.updateKycStatus();
        this.showToasterMessage('KYC completed', 'top', 'success');
        break;
      case 'auto_declined':
        this.updateKycStatus();
        this.showToasterMessage('KYC declined', 'top', 'danger');
        break;
      case 'manually_approved':
        this.updateKycStatus();
        this.showToasterMessage('KYC declined', 'top', 'danger');
        break;
      case 'needs_review':
        this.updateKycStatus();
        this.showToasterMessage('KYC needs review', 'top', 'danger');
        break;
    }
  };

  updateKycStatus() {
    this.httpClient.post(api.updateKYC, {}).subscribe((data) => {
      this.isKYCupdated$$.next(true);
        console.log('548 user')
      this.httpClient
        .get(api.UserProfile)
        .toPromise()
        .then((response: any) => {
          if (response && response.success) {
            this.store.dispatch({
              type: SET_PROFILE,
              userProfile: response['data'],
            });
          }
        });
    });
  }

  getKycDetails() {
    return this.httpClient.get(api.getKycDetails);
  }

  setUserRole(body: any) {
    return this.httpClient.put(api.setRole, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getDashboardData() {
    return this.httpClient.get(api.dashboard).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Reuse auth-guard responses when landing on /i-am-RA right after login. */
  captureIamraBootstrap(recentRa: any, recentSecret: any): void {
    this.iamraBootstrapSnapshot = {
      recentRa,
      recentSecret,
      capturedAt: Date.now(),
    };
  }

  consumeIamraBootstrap(): { recentRa?: any; recentSecret?: any } | null {
    const snapshot = this.iamraBootstrapSnapshot;
    if (!snapshot) {
      return null;
    }
    if (Date.now() - snapshot.capturedAt > CommonService.IAMRA_BOOTSTRAP_TTL_MS) {
      this.iamraBootstrapSnapshot = null;
      return null;
    }
    this.iamraBootstrapSnapshot = null;
    return {
      recentRa: snapshot.recentRa,
      recentSecret: snapshot.recentSecret,
    };
  }

  invalidateIamraRequestCache(): void {
    this.iamraInFlight.clear();
    this.iamraResponseCache.clear();
    this.iamraBootstrapSnapshot = null;
  }

  /** Logout / user switch — drop client + RA session keys so the next login cannot reuse the prior user. */
  clearClientAndIamraSessionStorage(): void {
    this.invalidateIamraRequestCache();
    this.clientAppDetails$$.next(null);
    const localKeys = [
      'reloadAfterRAApproval',
      'guardianDeviceIdForComparison',
      'clientAppDetails',
      'clientAppLastLiveVersion',
      'clientAppOpened',
      'clientAppInstalled',
      'clientAppVersionMismatch',
      'secureShellUpdatePendingLaunch',
      'isRecoveryInProgress',
      'preventReloadAfterRecoveryInit',
      'deviceMismatchInProgress',
      'preventReloadOnDeviceMismatch',
      'requestType',
    ];
    for (const key of localKeys) {
      try {
        localStorage.removeItem(key);
      } catch {
        /* ignore */
      }
    }
    const sessionKeys = [
      'activeStayOpenDeepLinkPage',
      'delegationStep2bLaunchInProgress',
    ];
    for (const key of sessionKeys) {
      try {
        sessionStorage.removeItem(key);
      } catch {
        /* ignore */
      }
    }
  }

  /** Scope in-memory /i-am-RA list cache to the logged-in user (survives SPA logout without full reload). */
  private iamraCacheScope(): string {
    try {
      const raw =
        sessionStorage.getItem('user') ||
        localStorage.getItem('user') ||
        sessionStorage.getItem('clocr_user');
      if (raw) {
        const user = JSON.parse(raw);
        const id = user?.id ?? user?.userId ?? user?.user_id;
        if (id != null && String(id).trim()) {
          return `uid:${String(id).trim()}`;
        }
        const email = user?.user_email ?? user?.email;
        if (email && String(email).trim()) {
          return `email:${String(email).trim().toLowerCase()}`;
        }
      }
    } catch {
      /* ignore */
    }
    const token = localStorage.getItem('token');
    if (token && token.length > 12) {
      return `tok:${token.length}:${token.slice(-16)}`;
    }
    return 'anonymous';
  }

  private iamraCacheKey(suffix: string): string {
    return `${this.iamraCacheScope()}:${suffix}`;
  }

  private getCachedIamraOrFetch<T>(key: string, factory: () => Observable<T>): Observable<T> {
    const scopedKey = this.iamraCacheKey(key);
    const cached = this.iamraResponseCache.get(scopedKey);
    if (cached && Date.now() - cached.capturedAt < CommonService.IAMRA_CACHE_TTL_MS) {
      return of(cached.value as T);
    }
    return this.dedupeIamraRequest(scopedKey, () =>
      factory().pipe(
        tap((value) => {
          this.iamraResponseCache.set(scopedKey, { capturedAt: Date.now(), value });
        }),
      ),
    );
  }

  private dedupeIamraRequest<T>(key: string, factory: () => Observable<T>): Observable<T> {
    const existing = this.iamraInFlight.get(key);
    if (existing) {
      return existing as Observable<T>;
    }
    const request = factory().pipe(
      share(),
      finalize(() => this.iamraInFlight.delete(key)),
    );
    this.iamraInFlight.set(key, request);
    return request;
  }

  getPastGuardiansRequests() {
    return this.getCachedIamraOrFetch('iamra-past-ra', () =>
      this.httpClient
        .get(api.getMeAsRaList, { params: { requestType: 'PAST_REQUEST' } })
        .pipe(map((response) => response)),
    );
  }

  getRecentGuardiansRequests() {
    return this.getCachedIamraOrFetch('iamra-recent-ra', () =>
      this.httpClient
        .get(api.getMeAsRaList, { params: { requestType: 'RECENT_REQUEST' } })
        .pipe(map((response) => response)),
    );
  }

  getRecoveryGuardiansRequests() {
    return this.httpClient.get(api.getRecoveryGuardian).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getSecretRecoveryRequests() {
    return this.httpClient.get(api.getSelfSecretRequests).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getClients() {
    return this.httpClient.get(api.clients).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getWillDetails(clientId: number) {
    return this.httpClient
      .get(api.willDetails, { params: { id: clientId } })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllWills() {
    return this.httpClient.get(api.allWills).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getClientAppStatus(): Observable<any> {
    return this.httpClient.get(api.clientAppStatus).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getThresholdCount(): Observable<any> {
    return this.httpClient.get(api.thersholdCount).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getRecentSecretKeysRequests(): Observable<any> {
    return this.getCachedIamraOrFetch('iamra-recent-secret', () =>
      this.httpClient
        .get(api.raDelegateSecretKeyRequests, {
          params: { dbName: 'clocrus', requestType: 'RECENT_REQUEST' },
        })
        .pipe(
          catchError(() =>
            this.httpClient.get(api.myRequestToRespond, {
              params: { requestType: 'RECENT_REQUEST' },
            }),
          ),
          map((response) => response),
        ),
    );
  }

  getPastSecretKeysRequests(): Observable<any> {
    return this.getCachedIamraOrFetch('iamra-past-secret', () =>
      this.httpClient
        .get(api.raDelegateSecretKeyRequests, {
          params: { dbName: 'clocrus', requestType: 'PAST_REQUEST' },
        })
        .pipe(
          catchError(() =>
            this.httpClient.get(api.myRequestToRespond, {
              params: { requestType: 'PAST_REQUEST' },
            }),
          ),
          map((response) => response),
        ),
    );
  }

  getTrusteeClients(): Observable<any> {
    return this.httpClient.get(api.trusteeClients).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getSecretVaultDetails(id: number): Observable<any> {
    return this.httpClient.get(api.vault, { params: { id } }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getAllVaults(): Observable<any> {
    return this.httpClient.get(api.allVaults).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getUserDetails(): Observable<any> {
    return this.httpClient.get(api.UserProfile).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getUserPermissions(): Observable<any> {
    return this.httpClient.get(api.getUserPermissions).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // Get all businesses/advisors for regular users (Advisor Access)
  getAllBusinessOfClient(): Observable<any> {
    return this.httpClient.get(api.getAllBusinessOfClient).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // Get specific business permissions for regular users
  getSpecificBusinessPermissions(companyId: any): Observable<any> {
    return this.httpClient.get(`${api.getSpecificBusinessPermissions}/${companyId}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // Update permissions by client for regular users
  updatePermissionsByClient(data: any): Observable<any> {
    return this.httpClient.put(api.updatePermissionsByClient, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  isUserExists(body: any): Observable<any> {
    return this.httpClient.post(api.userExists, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  registerUser(body: any): Observable<any> {
    return this.httpClient.put(api.register, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getGuardians(): Observable<any> {
    return this.httpClient.get(api.getRecoveryAgents).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getPlanList(): Observable<any> {
    return this.httpClient.get(api.subscriptionList).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getKycProducts(): Observable<any> {
    return this.httpClient.get(api.kycList).pipe(map((response) => response));
  }

  getKYCDetails(): Observable<any> {
    return this.httpClient
      .get(api.kycDetails)
      .pipe(map((response) => response));
  }

  getCreditLimitDetails(): Observable<any> {
    // Don't call this API when accessing from business/client dashboard
    const currentUrl = this.router.url || window.location.pathname || '';
    const isBusinessClientContext = currentUrl.includes('/business/client/');
    
    if (isBusinessClientContext) {
      console.log('[CommonService] Skipping creditLimit API call for business client context');
      // Return an empty observable to prevent the API call
      return of({ success: false, message: 'Skipped for business client context' });
    }
    
    return this.httpClient
      .get(api.creditLimit)
      .pipe(map((response) => response));
  }

  getDLSVCreditLimitDetails(options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    return this.httpClient
      .get(api.dlsvCreditLimit, headers ? { headers } : {})
      .pipe(map((response) => response));
  }

  createStripeSession(details: any, redirectUrl: any): Observable<any> {
    return this.httpClient
      .post(api.createSignupStripeSession, { ...details, redirectUrl })
      .pipe(map((response) => response));
  }

  createKycStripeSession(priceId: any, redirectUrl: any): Observable<any> {
    return this.httpClient
      .post(api.stripeSessionKyc, { priceId, redirectUrl })
      .pipe(map((response) => response));
  }

  setUserTimezone(timeZone: string): Observable<any> {
    return this.httpClient
      .put(api.timezone, { timeZone })
      .pipe(map((response) => response));
  }

  cancelSubscription(): Observable<any> {
    return this.httpClient
      .post(api.cancelSubscription, null)
      .pipe(map((response) => response));
  }

  resumeSubscription(): Observable<any> {
    return this.httpClient
      .post(api.resumeSubscription, null)
      .pipe(map((response) => response));
  }

  getSubscriptionHistoryData(): Observable<any> {
    return this.httpClient
      .get(api.subscriptionHistory)
      .pipe(map((response) => response));
  }

  getTrusteeDetails(): Observable<any> {
    return this.httpClient
      .get(api.trusteeRequestList)
      .pipe(map((response) => response));
  }

  deleteSecretKey(id: any): Observable<any> {
    return this.httpClient
      .delete(api.deleteSecretKey, { params: { id } })
      .pipe(map((response) => response));
  }

  getTrusts(): Observable<any> {
    return this.httpClient
      .get(api.trusts, this.b2bWillTrustHttpOptions())
      .pipe(map((response) => response));
  }

  saveTrust(body: any): Observable<any> {
    return this.httpClient
      .post(api.trusts, body, this.b2bWillTrustHttpOptions())
      .pipe(map((response) => response));
  }

  updateTrust(body: any): Observable<any> {
    return this.httpClient
      .put(api.trusts, body, this.b2bWillTrustHttpOptions())
      .pipe(map((response) => response));
  }

  deleteTrust(id: number): Observable<any> {
    return this.httpClient
      .delete(api.trusts, this.b2bWillTrustHttpOptions({ trust_id: id }))
      .pipe(map((response) => response));
  }

  addBinder(data: any) {
    let promise = new Promise((resolve, reject) => {
      this.savedBinders.push(data);
      resolve(this.savedBinders);
    });
    return promise;
  }

  updateBinder(data: any, index: number) {
    let promise = new Promise((resolve, reject) => {
      if (this.savedBinders.length) {
        this.savedBinders[index] = data;
      }
      resolve(this.savedBinders);
    });
    return promise;
  }

  getBinderData(clientId?: string | number, accessType?: string): Observable<any> {
    let params = new HttpParams();
    
    // Only add clientId and accessType if user is a business user
    const accountType = localStorage.getItem('accountType');
    const isBusinessUser = accountType === 'B';
    
    if (isBusinessUser && clientId) {
      params = params.set('clientId', String(clientId));
    }
    
    if (isBusinessUser && accessType) {
      params = params.set('accessType', accessType);
    }
    
    return this.httpClient
      .get(api.emergencyBinder, { params })
      .pipe(map((response) => response));
  }

  // Payment APIS
  getPromoCodeDetails(promocode: string, countryId: number, email?: string) {
    let url = api.getPromoDetails + '/' + promocode + '?countryId=' + countryId;
    if (email) {
      url += '&email=' + encodeURIComponent(email);
    }
    return this.httpClient
      .get(url)
      .pipe(map((response) => response));
  }

  sendMessage(message: string, sessionId: any, country: any): Observable<any> {
    // Define headers with 'skipLoader' set to 'true'
    const headers = new HttpHeaders().set('skipLoader', 'true');
    // Make POST request with headers
    return this.httpClient.post(
      api.askQuestion,
      { userQuestion: message, sessionId: sessionId, country: country },
      { headers }
    );
  }

  getLegacyInfo(): Observable<any> {
    // Define headers with 'skipLoader' set to 'true'
    const headers = new HttpHeaders().set('skipLoader', 'true');
    return this.httpClient
      .get(api.legacyInfo, { headers })
      .pipe(map((response) => response));
  }

  updateLegacyInfo(data: any): Observable<any> {
    // Define headers with 'skipLoader' set to 'true'
    const headers = new HttpHeaders().set('skipLoader', 'true');
    return this.httpClient
      .put(api.legacyInfo, data, { headers })
      .pipe(map((response) => response));
  }

  createLegacyInfo(data: any): Observable<any> {
    const headers = new HttpHeaders().set('skipLoader', 'true');
    return this.httpClient
      .post(api.legacyInfo, data, { headers })
      .pipe(map((response) => response));
  }

  updateHouseHoldDetails(data: any): Observable<any> {
    // Define headers with 'skipLoader' set to 'true'
    const headers = new HttpHeaders().set('skipLoader', 'true');
    return this.httpClient
      .post(api.houseHoldDetails, data, { headers })
      .pipe(map((response) => response));
  }

  // File Vault API's
  getFileCategories(options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    return this.httpClient.get(api.fileCategories, headers ? { headers } : {});
  }
  createFileCategory(data: any): Observable<any> {
    return this.httpClient.post(api.fileCategories, data);
  }
  updateFileCategory(data: any): Observable<any> {
    return this.httpClient.put(api.fileCategories, data);
  }
  deleteFileCategory(id: any): Observable<any> {
    return this.httpClient.delete(api.fileCategories, { params: { ...id } });
  }
  createNewFile(formData: any, options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    return this.httpClient.post(api.fileVaultAddFile, formData, headers ? { headers } : {});
  }
  getFilesList(binder?: string, options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    const url = api.fileVaultGetFiles + (binder ? '?binder=' + binder : '');
    return this.httpClient.get(url, headers ? { headers } : {});
  }
  deleteFileById(id: string | number): Observable<any> {
    return this.httpClient.delete(`${api.fileVaultFile}/${id}`)
  }
  getFileById(id: string | number): Observable<any> {
    return this.httpClient.get(`${api.fileVaultGetFiles}?id=${id}`)
  }
  getFileByAssetPortfolio(assetPortfolioCode: string, assetPortfolioId: string): Observable<any> {
    return this.httpClient.get(`${api.fileVaultGetFiles}?isAssetPortfolioFile=true&assetPortfolioCode=${assetPortfolioCode}&assetPortfolioId=${assetPortfolioId}`)
  }
  
  updateFileById(id: string | number, data: any, options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    return this.httpClient.put(`${api.fileVaultFile}/${id}`, data, headers ? { headers } : {});
  }
  updateFileICE(data: any, options?: { skipLoader?: boolean }): Observable<any> {
    const headers = options?.skipLoader
      ? new HttpHeaders({ skipLoader: 'true' })
      : undefined;
    return this.httpClient.post(`${api.fileIce}`, data, headers ? { headers } : {});
  }
  updateAssetIce(data: any): Observable<any> {
    return this.httpClient.put(`${api.updateAssetIce}`, data);
  }


  getUserIpAddress() {
    return this.httpClient.get(api.getUserIpDetails);
  }

  // online accounts
  getOnlineAccounts(): Observable<any> {
    return this.httpClient.get(api.onlineAccounts);
  }

  getOnlineAccountSources(): Observable<any> {
    const fallbackData: {
      success: boolean;
      data: Array<{
        id: number;
        code: string;
        title: string;
        created_at: string;
        updated_at: string | null;
      }>;
      message: string;
    } = {
      success: true,
      data: [
        {
          id: 1,
          code: 'SELF',
          title: 'Self',
          created_at: '2025-04-05T00:04:09.000Z',
          updated_at: null
        },
        {
          id: 2,
          code: 'OTHER',
          title: 'Other',
          created_at: '2025-04-05T00:04:09.000Z',
          updated_at: null
        },
        {
          id: 3,
          code: 'CHROME',
          title: 'Google Chrome',
          created_at: '2025-04-05T00:04:09.000Z',
          updated_at: null
        },
        {
          id: 4,
          code: 'BRAVE',
          title: 'Brave',
          created_at: '2025-04-05T00:04:09.000Z',
          updated_at: null
        },
        {
          id: 5,
          code: 'SAFARI',
          title: 'Safari',
          created_at: '2025-04-05T00:04:10.000Z',
          updated_at: null
        },
        {
          id: 6,
          code: 'EDGE',
          title: 'Microsoft Edge',
          created_at: '2025-04-05T00:04:10.000Z',
          updated_at: null
        },
        {
          id: 7,
          code: 'FIREFOX',
          title: 'Firefox',
          created_at: '2025-04-05T00:04:10.000Z',
          updated_at: null
        },
        {
          id: 8,
          code: 'OPERA',
          title: 'Opera',
          created_at: '2025-04-05T00:04:10.000Z',
          updated_at: null
        },
        {
          id: 9,
          code: 'DUCKDUCKGO',
          title: 'Duck Duck Go',
          created_at: '2025-04-05T00:04:10.000Z',
          updated_at: null
        },
        {
          id: 10,
          code: 'LASTPASS',
          title: 'Last Pass',
          created_at: '2025-04-05T00:04:11.000Z',
          updated_at: null
        },
        {
          id: 11,
          code: 'NORDPASS',
          title: 'Nord Pass',
          created_at: '2025-04-05T00:04:11.000Z',
          updated_at: null
        },
        {
          id: 12,
          code: 'ROBOFORM',
          title: 'Robo Form',
          created_at: '2025-04-05T00:04:11.000Z',
          updated_at: null
        },
        {
          id: 13,
          code: 'ONEPASSWORD',
          title: '1 Password',
          created_at: '2025-04-05T00:04:11.000Z',
          updated_at: null
        },
        {
          id: 14,
          code: 'PROTONPASS',
          title: 'Proton Pass',
          created_at: '2025-04-05T00:04:12.000Z',
          updated_at: null
        },
        {
          id: 15,
          code: 'BITWARTEN',
          title: 'Bitwarten',
          created_at: '2025-04-05T00:04:12.000Z',
          updated_at: null
        },
        {
          id: 16,
          code: 'DASHLANE',
          title: 'Dashlane',
          created_at: '2025-04-05T00:04:12.000Z',
          updated_at: null
        },
        {
          id: 17,
          code: 'KEEPER',
          title: 'Keeper',
          created_at: '2025-04-05T00:04:12.000Z',
          updated_at: null
        }
      ],
      message: 'fetched successfully'
    };

    return this.httpClient.get(api.sources).pipe(
      catchError((error) => {
        console.warn('Failed to fetch online account sources from API, using fallback data', error);
        return of(fallbackData);
      })
    );
  }

  createOnlineAccount(data: any): Observable<any> {
    return this.httpClient.post(api.onlineAccounts, data);
  }

  updateOnlineAccount(data: any): Observable<any> {
    return this.httpClient.put(api.onlineAccounts, data);
  }
  
  deleteAccountById(id: string | number): Observable<any> {
    return this.httpClient.delete(`${api.onlineAccounts}?id=${id}`);
  }

  // Method to notify when profile image is updated
  notifyProfileImageUpdated(): void {
    this.profileImageUpdated$$.next();
  }
}
